import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { WhatsButton } from '../../components';
import './header.css';
// acredito que seja mais organizar o conteúdo e ajustar o estilo
// e as mudanças de responsividade, tem tudo pra ser uma dorzinha de cabeça
// import headerImg from '../../assets/header-img.webp';
// fazer o esquema dos nove anos dinâmico também conforme o atual atual
import headerImg from '../../assets/header3.png';
import pt from '../../locales/pt.json';

// const getYearsSince2017 = () => {
//     const currentYear = new Date().getFullYear();
//     return currentYear - 2017;
// };

const Header = () => {

  return (
    <div className="psico__header header__padding" id="home">
      <div className="psico__header-content full">
        <AnimationOnScroll animateIn="fade-in-bottom" animateOnce="true" duration={0.8}>
          <h1>{pt.header.title}</h1>
          <p id="texto-aumentado"><b>{pt.header.subtitle}</b><br /></p>
          <p>{pt.header.content}</p>
          {/* <p>+10 anos ajudando pessoas!</p> */}
          {/* <p id="header-online">Experiência que gera Transformação Real: Com mais de 9 anos de prática clínica e +400 vidas transformadas</p> */}
          {/* <p><strong>+{getYearsSince2017()} {pt.header.years}</strong> | <strong>{pt.header.lifes}</strong></p> */}
          <p><strong>{pt.header.years}</strong></p>
          <p class="psico__header-content_gambiarra">{pt.header.online}</p>
          <p>{pt.header.fiftyMin}</p>
          {/* <p class="psico__header-content_gambiarra">{pt.header.thirtyMin} <a href="#infos"><strong>({pt.header.more})</strong></a><br /></p> */}
        </AnimationOnScroll>

        <AnimationOnScroll animateIn="fade-in-bottom" animateOnce="true" duration={0.8}>
          <div className="psico__header-content__message">
            <WhatsButton message={pt.whatsButton.message} />
          </div>
        </AnimationOnScroll>
      </div>

      <div className="psico__header-image">
        <AnimationOnScroll animateIn="fade-in-bottom" animateOnce="true" duration={0.8} offset={0}>
          <img src={headerImg} alt="Foto do profissional André Parreira." style={{ display: 'block', height: '100%', margin: 0 }} />
        </AnimationOnScroll>
      </div>

      <div className='psico__header-mobile'>
        <div className='psico__header-mobile-pic'>
          <AnimationOnScroll animateIn="fade-in-bottom" animateOnce="true" duration={0.8} offset={0}>
            <img src={headerImg} alt="Foto do profissional André Parreira." style={{ display: 'block', maxWidth: '100%', margin: 0 }} />
          </AnimationOnScroll>
        </div>

        <div className="psico__header-mobile-content">
          <AnimationOnScroll animateIn="fade-in-bottom" animateOnce="true" duration={0.8}>
            <h1>{pt.header.title}</h1>
            <p id="texto-aumentado"><b>{pt.header.subtitle}</b><br /></p>
            <p>{pt.header.content}</p>
            {/* <p>+10 anos ajudando pessoas!</p> */}
            {/* <p id="header-online">Experiência que gera Transformação Real: Com mais de 9 anos de prática clínica e +400 vidas transformadas</p> */}
            {/* <p><strong>+{getYearsSince2017()} {pt.header.years}</strong> | <strong>{pt.header.lifes}</strong></p> */}
          <p><strong>{pt.header.years}</strong></p>
            <p class="psico__header-content_gambiarra">{pt.header.online}</p>
            <p>{pt.header.fiftyMin}</p>
            {/* <p class="psico__header-content_gambiarra">{pt.header.thirtyMin} <a href="#infos"><strong>({pt.header.more})</strong></a><br /></p> */}
          </AnimationOnScroll>

          <AnimationOnScroll animateIn="fade-in-bottom" animateOnce="true" duration={0.8}>
            <div className="psico__header-content__message-mobile">
              <WhatsButton message={pt.whatsButton.message} />
            </div>
          </AnimationOnScroll>
        </div>
      </div>
    </div>
  )
}

export default Header
